module.exports = __webpack_public_path__ + "static/img/11.24a6f12.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/eng/11.png
// module id = hWVz
// module chunks = 0